import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { MONTHS } from "../lib/format";

const YEARS = [2025, 2026, 2027, 2028];

export function MonthYearPicker({ year, month, setYear, setMonth }) {
  return (
    <div className="flex gap-2">
      <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
        <SelectTrigger className="w-[140px] rounded-xl bg-white" data-testid="filter-month">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MONTHS.map((m, i) => (
            <SelectItem key={i} value={String(i + 1)} data-testid={`month-opt-${i + 1}`}>{m}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
        <SelectTrigger className="w-[110px] rounded-xl bg-white" data-testid="filter-year">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {YEARS.map((y) => (
            <SelectItem key={y} value={String(y)} data-testid={`year-opt-${y}`}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function SchoolPicker({ schools, schoolId, setSchoolId }) {
  return (
    <Select value={schoolId} onValueChange={setSchoolId}>
      <SelectTrigger className="w-[220px] rounded-xl bg-white" data-testid="filter-school">
        <SelectValue placeholder="Pilih Sekolah" />
      </SelectTrigger>
      <SelectContent>
        {schools.map((s) => (
          <SelectItem key={s.id} value={s.id} data-testid={`school-opt-${s.code}`}>{s.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
